/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './external-referral.reducer';

export const ExternalReferral = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const externalReferralList = useAppSelector(state => state.externalReferral.entities);
  const loading = useAppSelector(state => state.externalReferral.loading);
  const totalItems = useAppSelector(state => state.externalReferral.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="external-referral-heading" data-cy="ExternalReferralHeading">
        <Translate contentKey="tinyMedicRestApp.externalReferral.home.title">External Referrals</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.externalReferral.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/external-referral/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.externalReferral.home.createLabel">Create new External Referral</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.externalReferral.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {externalReferralList && externalReferralList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.externalReferral.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.externalReferral.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.externalReferral.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.externalReferral.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.externalReferral.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.externalReferral.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('referredById')}>
                  <Translate contentKey="tinyMedicRestApp.externalReferral.referredById">Referred By Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referredById')} />
                </th>
                <th className="hand" onClick={sort('referredByRole')}>
                  <Translate contentKey="tinyMedicRestApp.externalReferral.referredByRole">Referred By Role</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referredByRole')} />
                </th>
                <th className="hand" onClick={sort('referredDate')}>
                  <Translate contentKey="tinyMedicRestApp.externalReferral.referredDate">Referred Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referredDate')} />
                </th>
                <th className="hand" onClick={sort('referralNotes')}>
                  <Translate contentKey="tinyMedicRestApp.externalReferral.referralNotes">Referral Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referralNotes')} />
                </th>
                <th className="hand" onClick={sort('referringTenantId')}>
                  <Translate contentKey="tinyMedicRestApp.externalReferral.referringTenantId">Referring Tenant Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referringTenantId')} />
                </th>
                <th className="hand" onClick={sort('referringTenantType')}>
                  <Translate contentKey="tinyMedicRestApp.externalReferral.referringTenantType">Referring Tenant Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referringTenantType')} />
                </th>
                <th className="hand" onClick={sort('referredEntity')}>
                  <Translate contentKey="tinyMedicRestApp.externalReferral.referredEntity">Referred Entity</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referredEntity')} />
                </th>
                <th className="hand" onClick={sort('referredEntityType')}>
                  <Translate contentKey="tinyMedicRestApp.externalReferral.referredEntityType">Referred Entity Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referredEntityType')} />
                </th>
                <th className="hand" onClick={sort('referredEntityAddrLine1')}>
                  <Translate contentKey="tinyMedicRestApp.externalReferral.referredEntityAddrLine1">Referred Entity Addr Line 1</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referredEntityAddrLine1')} />
                </th>
                <th className="hand" onClick={sort('referredEntityAddrLine2')}>
                  <Translate contentKey="tinyMedicRestApp.externalReferral.referredEntityAddrLine2">Referred Entity Addr Line 2</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referredEntityAddrLine2')} />
                </th>
                <th className="hand" onClick={sort('referredEntityCity')}>
                  <Translate contentKey="tinyMedicRestApp.externalReferral.referredEntityCity">Referred Entity City</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referredEntityCity')} />
                </th>
                <th className="hand" onClick={sort('referredEntityState')}>
                  <Translate contentKey="tinyMedicRestApp.externalReferral.referredEntityState">Referred Entity State</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referredEntityState')} />
                </th>
                <th className="hand" onClick={sort('referredEntityPincode')}>
                  <Translate contentKey="tinyMedicRestApp.externalReferral.referredEntityPincode">Referred Entity Pincode</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referredEntityPincode')} />
                </th>
                <th className="hand" onClick={sort('referredToUser')}>
                  <Translate contentKey="tinyMedicRestApp.externalReferral.referredToUser">Referred To User</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referredToUser')} />
                </th>
                <th className="hand" onClick={sort('referredToRole')}>
                  <Translate contentKey="tinyMedicRestApp.externalReferral.referredToRole">Referred To Role</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referredToRole')} />
                </th>
                <th className="hand" onClick={sort('createdBy')}>
                  <Translate contentKey="tinyMedicRestApp.externalReferral.createdBy">Created By</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('createdBy')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.externalReferral.patient">Patient</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {externalReferralList.map((externalReferral, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/external-referral/${externalReferral.id}`} color="link" size="sm">
                      {externalReferral.id}
                    </Button>
                  </td>
                  <td>{externalReferral.timestampEntry}</td>
                  <td>{externalReferral.microSec}</td>
                  <td>{externalReferral.lastUpdated}</td>
                  <td>{externalReferral.active ? 'true' : 'false'}</td>
                  <td>{externalReferral.cursor}</td>
                  <td>{externalReferral.referredById}</td>
                  <td>{externalReferral.referredByRole}</td>
                  <td>{externalReferral.referredDate}</td>
                  <td>{externalReferral.referralNotes}</td>
                  <td>{externalReferral.referringTenantId}</td>
                  <td>{externalReferral.referringTenantType}</td>
                  <td>{externalReferral.referredEntity}</td>
                  <td>{externalReferral.referredEntityType}</td>
                  <td>{externalReferral.referredEntityAddrLine1}</td>
                  <td>{externalReferral.referredEntityAddrLine2}</td>
                  <td>{externalReferral.referredEntityCity}</td>
                  <td>{externalReferral.referredEntityState}</td>
                  <td>{externalReferral.referredEntityPincode}</td>
                  <td>{externalReferral.referredToUser}</td>
                  <td>{externalReferral.referredToRole}</td>
                  <td>{externalReferral.createdBy}</td>
                  <td>
                    {externalReferral.patient ? (
                      <Link to={`/gluco-user/${externalReferral.patient.id}`}>{externalReferral.patient.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/external-referral/${externalReferral.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/external-referral/${externalReferral.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/external-referral/${externalReferral.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.externalReferral.home.notFound">No External Referrals found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={externalReferralList && externalReferralList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default ExternalReferral;
